import { DeviceMobileIcon } from "@phosphor-icons/react/DeviceMobile";
import { Button } from "@freightsimple/ui-core/Controls/Button";

interface NavBarPairMobileDeviceButtonProps {
  onNavigate: (path: string) => void;
}

/**
 * "Pair Mobile Device" item for the user menu.
 *
 * A component rather than an inline Button because `fs/no-onclick-in-menu`
 * bans onClick inside a Menu tree. It routes through the nav's `onNavigate`
 * like every other nav item, rather than reaching for useNavigate itself.
 *
 * The caller decides whether to render it at all: employees / non-production
 * only, since the iOS app hasn't shipped to customers yet (ENG-6029).
 */
export function NavBarPairMobileDeviceButton({
  onNavigate,
}: NavBarPairMobileDeviceButtonProps) {
  return (
    <Button
      icon={DeviceMobileIcon}
      data-testid="subnav-Pair Mobile Device"
      onClick={() => onNavigate("/pair-mobile-device")}
    >
      Pair Mobile Device
    </Button>
  );
}
